import { Api } from 'utils';

class UserService {
  static client = {
    get: async (params = {}) => Api.createResponse('app/users/', params),
    getLawyer: async (params?: any) => Api.createResponse('app/users/lawyer', params),
    set_apacuana_id: async (params?: any) => Api.createResponse('app/users/apacuana-id', params),
  };

  static admin = {
    get: async (params?: any) => Api.createResponse('admin/users/get', params),
    create: async (params?: any) => Api.createResponse('admin/users/create', params),
    update: async (params?: any) => Api.createResponse('admin/users/update', params),
    delete: async (params?: any) => Api.createResponse('admin/users/delete', params),
    download: async (params?: any) => Api.createResponse('admin/users/download', params),
    // Export segmentado del botón "Descargar Excel" (ver Constants.LEAD_SEGMENTS
    // en el backend) -- clientes que nunca compraron una membresía de pago.
    downloadSQL: async (params?: any) =>
      Api.createResponse('admin/users/download', { ...params, segment: 'SQL' }),
    view: async (params?: any) => Api.createResponse('admin/users/view', params),
    getDocumentUrl: async (params?: any) => Api.createResponse('admin/users/document-url', params),
    changeActive: async (params?: any) => Api.createResponse('admin/users/change-active', params),
  };
}

export default UserService;
